import skizz from '../core/index'

import isFunction from './isFunction'
import guid from './guid'
import hash from './hash'
import rand from './rand'
import encode from './encode'
import decode from './decode'
import storage from './storage'
import noop from './noop'
import identity from './identity'
import memoize from './memoize'
import debounce from './debounce'
import throttle from './throttle'
import scrollTo from './scrollTo'

skizz.isFunction = isFunction
skizz.guid = guid
skizz.hash = hash
skizz.rand = rand
skizz.encode = encode
skizz.decode = decode
skizz.storage = storage
skizz.noop = noop
skizz.identity = identity
skizz.memoize = memoize
skizz.debounce = debounce
skizz.throttle = throttle
skizz.scrollTo = scrollTo
